/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import vue2Dropzone from 'vue2-dropzone';
Vue.use(vue2Dropzone);

import DatePicker from 'vue2-datepicker'
Vue.use(DatePicker)

import VuejsDialog from 'vuejs-dialog';
Vue.use(VuejsDialog, {
    html: true
});

Vue.use(require('vue-moment'));

import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('choose-properties', require('./components/choose-properties.vue').default);
Vue.component('upload-dropzone', require('./components/upload-dropzone.vue').default);
Vue.component('editor', require('./components/editor.vue').default);
Vue.component('product-form', require('./components/product/form.vue').default);
Vue.component('product-sku', require('./components/product/sku.vue').default);
Vue.component('datetime-input', require('./components/datetime-input.vue').default);

Vue.component('user-address', require('./components/address/index.vue').default);
Vue.component('choose-product', require('./components/choose-product.vue').default);
Vue.component('upload-file', require('./components/upload-file.vue').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
